var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-container"},[_c('base-list-management',{ref:"baseListManagementRef",attrs:{"configData":_setup.configData,"activeAutoQuery":false}}),_vm._v(" "),_c(_setup.modelDetailDrawer,{ref:"modelDetailDrawerRef",on:{"refresh":_setup.refreshTable}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }